export const controls = {
  title: 'Manage controls',
  description: 'Add, edit, delete controls and manage their order',
  addControl: 'Add control',
  deleteTitle: 'Are you sure you want to delete control: {code}?',
  createdSuccess: 'Control created successfully',
  updatedSuccess: 'Control updated successfully',
  deletedSuccess: 'Control deleted successfully',
  updatedIndexSuccess: 'Controls order updated',
  noControls: 'No controls',
  showHide: 'show / hide',
  heading: 'Controls',
  fields: {
    code: 'Code',
    label: 'Label',
    type: 'Type',
    defaultValue: 'Default value',
    isDisabled: 'Disabled?',
    isVisible: 'Visible?',
    isDisabledBadge: 'Disabled',
    isVisibleBadge: 'Hidden',
  },
  types: {
    toggle: 'Toggle (yes/no)',
  },
  tooltip: {
    edit: 'Edit',
    delete: 'Delete',
    move: 'Drag to reorder',
    isDisabled:
      'Should the control be visible but unavailable for selection on the configuration screen?',
    isVisible: 'Should the control be hidden on the configuration screen?',
  },
} as const
